<template>
  <button v-if="func == 'button'"  type="submit"  :disabled="loading" class="flex items-center justify-center relative w-min mx-1.5 p-2 px-4 text-sm rounded border group transition-colors 1s ease-in-out" :class="[inverted ? 'bg-transparent hover:bg-orfBlue-100 text-orfBlue-100 border-orfBlue-100 hover:text-white' : 'bg-orfBlue-100 hover:bg-white text-white border-orfBlue-100 hover:text-orfBlue-100', small ? 'h-8' : 'h-10']">
    <div v-if="loading" class="btn-spinner border-orfBlue-100 absolute" />
    <div class="whitespace-nowrap" :class="[{'invisible' : loading }, 'flex items-center justify-center']">
      <HeroIcon :name="iconName" class="w-4 " :mini="iconMini" :solid="iconSolid" :outline="iconOutline" :custom-icon="iconCustomIcon" :class="[inverted ? 'fill-orfBlue-100 group-hover:fill-white' : 'fill-white group-hover:fill-orfBlue-100']"/>
      <div v-if="!noText" class="mt-0.5" :class="{'ml-1' : !noIcon}">{{text}}</div>
    </div>
  </button>
  <button v-else-if="func == 'büro'"  type="submit"  :disabled="loading" class="flex items-center justify-center relative w-min mx-1.5 p-2 px-4 text-sm rounded border group transition-colors 1s ease-in-out" :class="[inverted ? 'bg-transparent hover:bg-büro-100 text-büro-100 border-büro-100 hover:text-white' : 'bg-büro-100 hover:bg-white text-white border-büro-100 hover:text-büro-100', small ? 'h-8' : 'h-10']">
    <div v-if="loading" class="btn-spinner border-büro-100 absolute" />
    <div class="whitespace-nowrap" :class="[{'invisible' : loading }, 'flex items-center justify-center']">
      <HeroIcon :name="iconName" class="w-4 " :mini="iconMini" :solid="iconSolid" :outline="iconOutline" :custom-icon="iconCustomIcon" :class="[inverted ? 'fill-büro-100 group-hover:fill-white' : 'fill-white group-hover:fill-büro-100']"/>
      <div v-if="!noText" class="mt-0.5" :class="{'ml-1' : !noIcon}">{{text}}</div>
    </div>
  </button>
  <button v-else-if="func == 'urlaub'"  type="submit"  :disabled="loading" class="flex items-center justify-center relative w-min mx-1.5 p-2 px-4 text-sm rounded border group transition-colors 1s ease-in-out" :class="[inverted ? 'bg-transparent hover:bg-urlaub-100 text-urlaub-100 border-urlaub-100 hover:text-white' : 'bg-urlaub-100 hover:bg-white text-white border-urlaub-100 hover:text-urlaub-100', small ? 'h-8' : 'h-10']">
    <div v-if="loading" class="btn-spinner border-urlaub-100 absolute" />
    <div class="whitespace-nowrap" :class="[{'invisible' : loading }, 'flex items-center justify-center']">
      <HeroIcon :name="iconName" class="w-4 " :mini="iconMini" :solid="iconSolid" :outline="iconOutline" :custom-icon="iconCustomIcon" :class="[inverted ? 'fill-urlaub-100 group-hover:fill-white' : 'fill-white group-hover:fill-urlaub-100']"/>
      <div v-if="!noText" class="mt-0.5" :class="{'ml-1' : !noIcon}">{{text}}</div>
    </div>
  </button>
  <button v-else-if="func == 'delete'" :disabled="loading" class="flex items-center justify-center relative w-min mx-1.5 p-2 px-4 text-sm rounded border group transition-colors 1s ease-in-out" :class="[inverted ? 'bg-transparent hover:bg-orfRed-100 text-orfRed-100 border-orfRed-100 hover:text-white' : 'bg-orfRed-100 hover:bg-white text-white border-orfRed-100 hover:text-orfRed-100', small ? 'h-8' : 'h-10']">
    <div v-if="loading" class="btn-spinner border-orfRed-100 absolute" />
    <div class="whitespace-nowrap" :class="[{'invisible' : loading }, 'flex items-center justify-center', small ? 'text-xs' : '']">
      <HeroIcon :name="iconName" class="w-4 " :mini="iconMini" :solid="iconSolid" :outline="iconOutline" :custom-icon="iconCustomIcon" :class="[inverted ? 'fill-orfRed-100 group-hover:fill-white' : 'fill-white group-hover:fill-orfRed-100']"/>
      <div v-if="!noText" class="mt-0.5" :class="{'ml-1' : !noIcon}">{{text}}</div>
    </div>
  </button>
  <button v-else-if="func == 'admin'" :disabled="loading" class="flex items-center justify-center relative w-min mx-1.5 p-2 px-4 text-sm rounded border group transition-colors 1s ease-in-out" :class="[inverted ? 'bg-transparent hover:bg-gray-300 text-gray-300 border-gray-300 hover:text-white' : 'bg-gray-300 hover:bg-white text-white border-gray-300 hover:text-gray-300', small ? 'h-8' : 'h-10']">
    <div v-if="loading" class="btn-spinner border-gray-300 absolute" />
    <div class="whitespace-nowrap" :class="[{'invisible' : loading }, 'flex items-center justify-center', small ? 'text-xs' : '']">
      <HeroIcon :name="iconName" class="w-4 " :mini="iconMini" :solid="iconSolid" :outline="iconOutline" :custom-icon="iconCustomIcon" :class="[inverted ? 'fill-gray-300 group-hover:fill-white' : 'fill-white group-hover:fill-gray-300']"/>
      <div v-if="!noText" class="mt-0.5" :class="{'ml-1' : !noIcon}">{{text}}</div>
    </div>
  </button>
  <Link v-else :href="href" :disabled="loading" class="flex items-center justify-center relative w-min mx-1.5 p-2 px-4 text-sm rounded border group transition-colors 1s ease-in-out" :class="[inverted ? 'bg-transparent hover:bg-orfBlue-100 text-orfBlue-100 border-orfBlue-100 hover:text-white' : 'bg-orfBlue-100 hover:bg-white text-white border-orfBlue-100 hover:text-orfBlue-100', small ? 'h-8' : 'h-10']">
    <div v-if="loading" class="btn-spinner border-orfBlue-100 absolute" />
    <div class="whitespace-nowrap" :class="[{'invisible' : loading }, 'flex items-center justify-center', small ? 'text-xs' : '']">
      <HeroIcon :name="iconName" class="w-4 " :mini="iconMini" :solid="iconSolid" :outline="iconOutline" :custom-icon="iconCustomIcon" :class="[inverted ? 'fill-orfBlue-100 group-hover:fill-white' : 'fill-white group-hover:fill-orfBlue-100']"/>
      <div v-if="!noText" class="mt-0.5" :class="{'ml-1' : !noIcon}">{{text}}</div>
    </div>
  </Link>
</template>

<script>
import HeroIcon from '@/Shared/HeroIcon.vue'
import { Head, Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    HeroIcon,
    Link,
  },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    func: {
      type: String,
      default: 'button',
    },
    href: String,
    inverted: {
      type: Boolean,
      default: false,
    },
    noText: {
      type: Boolean,
      default: false,
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: null,
    },
    loading: Boolean,
    iconName: String,
    text: String,
    iconMini:  {
      type: Boolean,
      default: false,
    },
    iconSolid:  {
      type: Boolean,
      default: false,
    },
    iconOutline:  {
      type: Boolean,
      default: false,
    },
    iconCustomIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
